var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMHat3NewHair3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "new-hair-3_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D0E09B",
    d: "M477.2,181.2c20.6,9.9,7.8,54.5,4.1,66.4c17.7-13.7,41.8-38.3,46.6-59.8c4.9-21.6,21.5-63.5-23.3-109.3 c-32.7-33.3-87.9-61-123.3-62c-39.4-1.2-107.7,16.3-138.7,34c-46.7,26.7-70,80.7-69.3,104c0.6,19.9,4.2,46.7,15.3,62 c7.4,10.1,22.1,22.1,36,22.7c-13.2-9.2-18-51.3,10.7-52.7c-12.8-16.6,44.2-18,53.5-18.8c39.7-3.4,81.6-7.8,121,1.3 C432.6,174.3,460.2,171,477.2,181.2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "hats_new-hair-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m-hat3_7_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6F3C1B",
    d: "M529,155.1c-1.3-18.6-33-18.9-46.9-19.9c-40.8-2.9-80.7,4.7-122.4,4.4c-29.3-0.2-60.4-3.3-92.2-6.1 l-3.8-0.6c-12.4-1.8-34.6,1.1-47.5,4.4c-14.9,3.8-35.5,15.1-24.3,34.3c7.2,12.4,31.1,27.3,43.7,32.6c16.8,7,29.8,11.7,47.5,15.9 c35.3,8.5,71.8,5.2,107.3,0.7c36.2-4.6,71.4-12.4,104.8-29.7C508,184.5,530.2,172.9,529,155.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F3C1B",
    d: "M438.5,75.7c-9.6-5-21.8-7.8-31.6-12.2c-10.2-4.6-15.5-13.1-25.2-19.1C360.5,31.6,330,47.3,312,59.9 c-23,15.9-38.4,5.3-53.9,25.4c-7.5,9.7-8.3,24.1-8.6,36.1c-0.2,7.4,0.4,19.4,1.2,30.3c1.4,0.9,2.8,1.8,4.2,2.7 c55.2,33.9,128.6,37.2,188.3,10.6c5.7-2.7,11.3-5.7,16.8-9c1.4-0.8,2.8-1.7,4.1-2.6c-0.2-4.6-0.4-8.8-0.6-11.6 C461.1,116.9,463.7,88.7,438.5,75.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CCB37F",
    d: "M461.8,119.9c-0.9,0.4-1.7,0.8-2.6,1.2c-5.6,2.6-11.4,5-17.2,7.2c-57.6,20.2-122.3,19.1-178.5-4.6 c-4.7-2-9.4-4.2-14-6.5c-0.1,1.4-0.1,2.8-0.2,4.2c-0.2,7.4,0.4,19.4,1.2,30.3c1.4,0.9,2.8,1.8,4.2,2.7 c55.2,33.9,128.6,37.2,188.3,10.6c5.7-2.7,11.3-5.7,16.8-9c1.4-0.8,2.8-1.7,4.1-2.6c-0.2-4.6-0.4-8.8-0.6-11.6 C462.7,134.6,462.5,127.2,461.8,119.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#41210D",
    d: "M360.7,97.6c20.9-3.3,35.2-17.6,47.7-33.5c-0.5-0.2-1-0.4-1.5-0.6c-10.2-4.6-15.5-13.1-25.2-19.1 C360.5,31.6,330,47.3,312,59.9c-4,2.8-7.8,4.7-11.3,6.2c1.2,2.3,2.6,4.5,4.1,6.6C316.5,91,339.1,101,360.7,97.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#41210D",
    d: "M464,153.3c-0.2-4.6-0.4-8.8-0.6-11.6c-2-21.8-0.2-46.3-17-60.8c-5.7,26.7,0.7,54,3.7,80.6 c3.3-1.7,6.6-3.6,9.8-5.6C461.3,155.1,462.6,154.2,464,153.3z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#41210D",
    d: "M283,102.1c38.9,24.4,96,25.4,133.8-2.2c-12.9,26.5-53.8,30-79.6,27.8C314.5,125.5,300.3,118.6,283,102.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE7B6",
    d: "M327.8,140.7c-7.2,11.5-12.9,21.8-22.9,35.1c3.6,1,7.2,1.8,10.8,2.5c10.3-13.8,16.1-24.4,23.7-36.5 C335.6,141.5,331.7,141.2,327.8,140.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE7B6",
    d: "M375.4,141.9c-8.7,13.2-18.6,28.4-28.7,40.4c14.8,0.8,29.8,0.1,44.5-2.2c8.7-13.5,16.8-30.1,23.9-44.1 C402,139.1,388.8,141,375.4,141.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMHat3NewHair3);
export default __webpack_public_path__ + "static/media/m-hat3_new-hair3.bfdff56bedcc9e91c0bd7f10e6f71f4d.svg";
export { ForwardRef as ReactComponent };